import React, { useState } from 'react';
import { StyledTitle } from './styled';
import { Form, Button, Tooltip } from 'antd';
import { eventTypeOfMappedEvent } from '@src/common/constant/enum';
import { FlowNWR } from './FlowNWR';

const FlowNetworkRequestPatterns = ({ mode, value, onChange }) => {
  const [localNetworkRequestPatterns, setLocalNetworkRequestPatterns] = useState(value || []);
  const isFormViewMode = mode === 'view';

  return (
    <div>
      <StyledTitle>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <Tooltip title="Only the network requests that match these rules contribute to the Flow metrics.">
            <div>Associate Network Requests with the Flow</div>
          </Tooltip>
        </div>
      </StyledTitle>
      {mode !== 'view' && (
        <div style={{ paddingLeft: '8px', marginBottom: '15px' }}>
          {localNetworkRequestPatterns.length === 0 && (
            <div>
              The network request metrics in Flow only count those network requests matching rules
              configured below.
            </div>
          )}
        </div>
      )}
      {localNetworkRequestPatterns.map((networkRequest, index) => (
        <FlowNWR
          key={`${networkRequest.id || 'new'}-${JSON.stringify(networkRequest)}`}
          networkRequest={networkRequest}
          onSave={(updatedNetworkRequest) => {
            const newValue = [...localNetworkRequestPatterns];
            newValue[index] = updatedNetworkRequest;
            setLocalNetworkRequestPatterns(newValue);
            onChange?.(newValue);
          }}
          onDelete={() => {
            const newValue = localNetworkRequestPatterns.filter((_, i) => i !== index);
            setLocalNetworkRequestPatterns(newValue);
            onChange?.(newValue);
          }}
          mode={mode}
        />
      ))}

      {mode !== 'view' && (
        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Button
            type="link"
            onClick={() => {
              const newNetworkRequest = {
                isRecommended: false,
                rules: [
                  [
                    {
                      key: eventTypeOfMappedEvent.all_event_name,
                      op: 'eq',
                      value: ['conviva_network_request'],
                      mapping_rules: [
                        [
                          {
                            tag_key: {
                              op: 'eq',
                              value: ['network_request_url_path'],
                            },
                            tag_value: {
                              op: 'match pattern',
                              value: [],
                            },
                          },
                        ],
                      ],
                      metadata: [],
                    },
                  ],
                ],
              };
              setLocalNetworkRequestPatterns([...localNetworkRequestPatterns, newNetworkRequest]);
            }}
          >
            + Add Network Request
          </Button>
        </div>
      )}
    </div>
  );
};

const FlowNetworkRequestPatternsFormItem = ({ mode, form }) => {
  return (
    <Form.Item name={['definition', 'network_request_patterns']}>
      {/*@ts-ignore*/}
      <FlowNetworkRequestPatterns mode={mode} form={form} />
    </Form.Item>
  );
};

export default FlowNetworkRequestPatternsFormItem;
